{
  "propertyManager": "Housing manager",
  "propertyMaintenance": "Property maintenance services",
  "customerService": "Customer service",
  "residentsCommittee": "Residents committee",
  "contactInformation": "Contact information",
  "contactMaintenanceOrManager": "Should I contact property manager or maintenance service?",
  "call": "Call",
  "email": "Send email to",
  "errors": {
    "title": "Error",
    "failedToLoadContacts": "Failed to load contact information. Please try again later."
  },
  "democracyRoles": {
    "chairperson": "Chairperson",
    "vice_chairperson": "Vice chairperson",
    "member": "Member",
    "treasurer": "Treasurer",
    "secretary": "Secretary",
    "contact_person": "Contact person",
    "representative": "Representative",
    "board_member": "Board member",
    "supervisor": "Supervisor"
  },
  "legal": {
    "privacyStatementLinkText": "Privacy statement",
    "accessibilityStatementLinkText": "Accessibility statement",
    "termsOfUseLinkText": "Terms and conditions of use",
    "privacyStatementLink": "https://www.rsa.fi/tietosuojaseloste/",
    "accessibilityStatementLink": "",
    "termsOfUseLink": ""
  },
  "question": {
    "title": "Ask about housing",
    "description": "Use this form to ask us about housing-related matters. We aim to answer within a few days.",
    "button": "Ask about housing"
  },
  "feedback": {
    "title": "Give feedback",
    "description": "With this form you can give feedback to the housing company or maintenance company. We will get back to you on the matter if necessary within about 10 business days.",
    "button": "Give feedback"
  }
}